<div class="map-button-element mb-2 {{ styleButton }}" matTooltip="{{ btnOptions.tooltip }}" matTooltipClass="tooltip-map-button" matTooltipPosition="right">
  <img [src]="btnOptions.ico" alt="" />
</div>
